// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plugin_preview_style[data-v-fbf61d24]{height:100%;max-width:100%;background-color:#fff}", ""]);
// Exports
module.exports = exports;
